import React from "react";
import { GridManagementButtons } from "@client.components/UserManagementContent";
import { formatDate } from "@client.utils/dateUtils";
import GridHeader from "@client.components/GridHeader";
import { DateFormat } from "@client.enums/dateTypes";

const getNameGetter = ({ data }) => {
  return `${data.firstName} ${data.lastName}`;
};

export const getUserColumns = (t) => [
  {
    field: "firstName",
    headerName: t("components.UsersDataTable.grid.name"),
    headerComponent: GridHeader,
    cellClass: "data-table-cell cell-name",
    valueGetter: getNameGetter,
    tooltipValueGetter: getNameGetter,
    valueFormatter: getNameGetter,
  },
  {
    field: "email",
    tooltipField: "email",
    headerName: t("components.UsersDataTable.grid.email"),
    headerComponent: GridHeader,
  },
  {
    field: "createdAt",
    tooltipField: "createdAt",
    maxWidth: 120,
    headerName: t("components.UsersDataTable.grid.creationDate"),
    headerComponent: GridHeader,
    valueFormatter: (params) => {
      if (params.value) {
        const formattedDate = formatDate(params.value, DateFormat);
        return formattedDate;
      }
      return "";
    },
  },
  {
    field: "role",
    tooltipField: "role",
    maxWidth: 120,
    headerName: t("components.UsersDataTable.grid.role"),
    headerComponent: GridHeader,
  },
  {
    field: "teams",
    headerName: t("components.UsersDataTable.grid.teams"),
    headerComponent: GridHeader,
    cellRenderer: ({ value }) => value.map((t) => t.name).join(", "),
    tooltipValueGetter: ({ data }) => {
      return data.teams.length > 0
        ? data.teams.map((t) => t.name).join(", ")
        : null;
    },
  },
  {
    headerName: "",
    cellRenderer: ({ data }) => <GridManagementButtons user={data} />,
    maxWidth: 70,
  },
];
